var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPanel)?_c('div',{staticClass:"invite-public-share",staticStyle:{"display":"block"}},[_c('Panel',_vm._b({on:{"share":_vm.handleShare}},'Panel',_vm.config,false))],1):_c('div',{staticStyle:{"display":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }